import { webAPI } from "../../../axiosInstance";

const getAllBanners = async () => {
  const response = await webAPI.get("/banners");
  return response.data;
};

const addBanners = async (data: any) => {
  const response = await webAPI.post("/banners/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const updateBanners = async (data: any) => {
  const response = await webAPI.put(`/banners/update/${data?.id}`, data?.data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const deleteBanner = async (data: any) => {
  const response = await webAPI.delete(`/banners/delete/${data}`);
  return response.data;
};

export { getAllBanners, addBanners, updateBanners, deleteBanner };
